module.exports = __webpack_public_path__ + "static/img/logo.09b0c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/logo.png
// module id = vDal
// module chunks = 1